var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';
import { useBlocker, useNavigate } from 'react-router-dom';
import { StatusPermission } from '../../enum';
import { ROUTER_URL } from '../../router/constants';
import { useOrgConfigPermission } from '../app/selectors';
import { ConfirmDialog } from '../common/confirmDialog';
import { ExitBar } from '../common/exitBar';
import { PageBody } from '../layout/styled';
import { OrgConfigActions } from './actions';
import { ClientsLobsStep } from './clients/ClientsLobsStep';
import { resolveExceptionMessage } from './common/resolveExceptionMessage';
import { waitForApiSliceTerminal } from './common/waitForApiSliceTerminal';
import { OrgConfigStep } from './constants';
import { OrgConfigWizardContext, useOrgConfigWizardParams } from './context';
import { OrgConfigDescription } from './description';
import { FinancialsStep } from './financials/FinancialsStep';
import { HoursStep } from './hours';
import { LocationStepLayout } from './locations/LocationStepLayout';
import { LocationsStep } from './locations/LocationsStep';
import { ReviewStep } from './review/ReviewStep';
import { SeatsStep } from './seats/SeatsStep';
import { useFinalizeVersionAPI } from './selectors';
import { ShrinkageStep } from './shrinkage/ShrinkageStep';
import { StaffSettingsStep } from './staffSettings/StaffSettingsStep';
import { StaffingStep } from './staffing';
import { OrgConfigSteps } from './stepper';
export var OrgConfigLeaveConfirmation = function () {
  var t = useTranslation().t;
  var navigate = useNavigate();
  var store = useStore();
  var _a = useContext(OrgConfigWizardContext),
    checkIsDirty = _a.checkIsDirty,
    hasTouchedSession = _a.hasTouchedSession,
    markSessionDirty = _a.markSessionDirty,
    beforeNext = _a.beforeNext,
    isSaving = _a.isSaving,
    setIsSaving = _a.setIsSaving,
    isViewOnly = _a.isViewOnly,
    allowExit = _a.allowExit,
    hasUnpublishedChanges = _a.hasUnpublishedChanges;
  var _b = useFinalizeVersionAPI(),
    finalizeVersion = _b[1];
  var blocker = useBlocker(function (_a) {
    var _b, _c, _d;
    var nextLocation = _a.nextLocation;
    if (isViewOnly) return false;
    if (allowExit === null || allowExit === void 0 ? void 0 : allowExit.current) return false;
    var isExiting = !nextLocation.pathname.startsWith(ROUTER_URL.OrganizationWizard);
    var isCurrentlyDirty = (_c = (_b = checkIsDirty === null || checkIsDirty === void 0 ? void 0 : checkIsDirty.current) === null || _b === void 0 ? void 0 : _b.call(checkIsDirty)) !== null && _c !== void 0 ? _c : false;
    if (isCurrentlyDirty) {
      markSessionDirty === null || markSessionDirty === void 0 ? void 0 : markSessionDirty();
    }
    var isDirty = isCurrentlyDirty || ((_d = hasTouchedSession === null || hasTouchedSession === void 0 ? void 0 : hasTouchedSession.current) !== null && _d !== void 0 ? _d : false) || hasUnpublishedChanges;
    return isDirty && isExiting;
  });
  var _c = useState(undefined),
    dialogError = _c[0],
    setDialogError = _c[1];
  if (blocker.state !== 'blocked') return null;
  var handleContinue = function () {
    blocker.reset();
  };
  var handleExit = function () {
    if (allowExit) allowExit.current = true;
    blocker.reset();
    navigate(ROUTER_URL.Organization);
  };
  var handleFinish = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var saved, ok, slice, _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            setDialogError(undefined);
            setIsSaving(true);
            _b.label = 1;
          case 1:
            _b.trys.push([1, 5, 6, 7]);
            if (!beforeNext) return [3 /*break*/, 3];
            return [4 /*yield*/, beforeNext()];
          case 2:
            saved = _b.sent();
            if (!saved) {
              setIsSaving(false);
              blocker.reset();
              return [2 /*return*/];
            }
            _b.label = 3;
          case 3:
            return [4 /*yield*/, waitForApiSliceTerminal(store, 'orgConfigVersionFinalize:POST', finalizeVersion)];
          case 4:
            ok = _b.sent();
            if (!ok) {
              slice = store.getState().api['orgConfigVersionFinalize:POST'];
              setDialogError({
                message: resolveExceptionMessage(slice === null || slice === void 0 ? void 0 : slice.error, t, t('error.internalError', {
                  defaultValue: 'Failed to finalize configuration.'
                }))
              });
              setIsSaving(false);
              blocker.reset();
              return [2 /*return*/];
            }
            if (allowExit) allowExit.current = true;
            blocker.reset();
            navigate("".concat(ROUTER_URL.Organization, "?configured=1"));
            return [3 /*break*/, 7];
          case 5:
            _a = _b.sent();
            setDialogError({
              message: t('error.internalError', {
                defaultValue: 'Failed to finalize configuration.'
              })
            });
            blocker.reset();
            return [3 /*break*/, 7];
          case 6:
            setIsSaving(false);
            return [7 /*endfinally*/];
          case 7:
            return [2 /*return*/];
        }
      });
    });
  };
  return _jsx(ConfirmDialog, {
    open: blocker.state === 'blocked',
    onClose: handleContinue,
    title: t('confirmation.orgConfigExit.title'),
    message: t('confirmation.orgConfigExit.message'),
    cancelButtonText: "continueConfiguration",
    skipSaveButtonText: "exitUpper",
    confirmButtonText: "finish",
    onConfirm: handleFinish,
    onSkipSaveConfirm: handleExit,
    loading: isSaving,
    errors: dialogError ? [dialogError] : []
  });
};
var ComponentByStep = (_a = {}, _a[OrgConfigStep.Locations] = LocationsStep, _a[OrgConfigStep.Hours] = HoursStep, _a[OrgConfigStep.StaffSettings] = StaffSettingsStep, _a[OrgConfigStep.Shrinkage] = ShrinkageStep, _a[OrgConfigStep.SupportRoles] = StaffingStep, _a[OrgConfigStep.Financials] = FinancialsStep, _a[OrgConfigStep.ClientsLobs] = ClientsLobsStep, _a[OrgConfigStep.Seats] = SeatsStep, _a[OrgConfigStep.Review] = ReviewStep, _a);
var OrgConfigWizardContent = function (_a) {
  var isViewOnly = _a.isViewOnly;
  var t = useTranslation('orgConfig').t;
  var params = useOrgConfigWizardParams({
    isViewOnly: isViewOnly
  });
  var step = params.step,
    stepIndex = params.stepIndex;
  var Component = ComponentByStep[step];
  return _jsxs(OrgConfigWizardContext.Provider, __assign({
    value: params
  }, {
    children: [_jsx(OrgConfigLeaveConfirmation, {}), _jsx(ExitBar, {
      title: t('orgConfigWizard.title'),
      exitTo: ROUTER_URL.Organization,
      bypassConfirm: true
    }), _jsx(OrgConfigSteps, {}), _jsxs(PageBody, {
      children: [_jsx(OrgConfigDescription, {
        titleSlot: _jsx(OrgConfigActions, {
          topVariant: true
        })
      }), _jsx(LocationStepLayout, {
        children: _jsx(Component, {
          step: step,
          stepIndex: stepIndex
        })
      }), _jsx(OrgConfigActions, {})]
    })]
  }));
};
export var OrgConfigWizard = function () {
  var orgConfigPermission = useOrgConfigPermission();
  var isViewOnly = orgConfigPermission === StatusPermission.View;
  return _jsx(OrgConfigWizardContent, {
    isViewOnly: isViewOnly
  });
};